<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <circle cx="10" cy="10" r="7" fill="#00B42A" stroke="#00B42A" stroke-width="2" stroke-linejoin="round"/>
  <path d="M7 10.3911L9.55809 13L13 7" stroke="white" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>